// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.button-hide[data-v-25c41344]{\n  font-size: 20px;\n  position: absolute;\n  top: 0;\n  right: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
